"use client";

import type { ReactNode } from "react";
import type { MacaronRenderContext, RecordAny } from "./types";
import { MacaronButton } from "./MacaronButton";
import { MacaronCard } from "./MacaronCard";
import { MacaronCircularProgress } from "./MacaronCircularProgress";
import { MacaronColumn } from "./MacaronColumn";
import { MacaronDivider } from "./MacaronDivider";
import { MacaronActionSelectionList } from "./MacaronActionSelectionList";
import { MacaronBooleanAllOf } from "./MacaronBooleanAllOf";
import { MacaronBooleanAnyOf } from "./MacaronBooleanAnyOf";
import { MacaronBottomBar } from "./MacaronBottomBar";
import { MacaronCarousel } from "./MacaronCarousel";
import { MacaronDateTimeInput } from "./MacaronDateTimeInput";
import { MacaronDropdownSelection } from "./MacaronDropdownSelection";
import { MacaronFilterTags } from "./MacaronFilterTags";
import { MacaronFullScreenModal } from "./MacaronFullScreenModal";
import { MacaronIcon } from "./MacaronIcon";
import { MacaronImage } from "./MacaronImage";
import { MacaronLabel } from "./MacaronLabel";
import { MacaronLinearProgress } from "./MacaronLinearProgress";
import { MacaronMap } from "./MacaronMap";
import { MacaronMarkdownView } from "./MacaronMarkdownView";
import { MacaronOrderedDisplayList } from "./MacaronOrderedDisplayList";
import { MacaronOrderedSelectionList } from "./MacaronOrderedSelectionList";
import { MacaronPasswordKeypad } from "./MacaronPasswordKeypad";
import { MacaronPhotoInput } from "./MacaronPhotoInput";
import { MacaronRating } from "./MacaronRating";
import { MacaronRollPicker } from "./MacaronRollPicker";
import { MacaronRollPickerCard } from "./MacaronRollPickerCard";
import { MacaronRow } from "./MacaronRow";
import { MacaronSelectionGrid } from "./MacaronSelectionGrid";
import { MacaronSelectionList } from "./MacaronSelectionList";
import { MacaronSelectionWrap } from "./MacaronSelectionWrap";
import { MacaronStub } from "./MacaronStub";
import { MacaronTagText } from "./MacaronTagText";
import { MacaronTabs } from "./MacaronTabs";
import { MacaronTickSlider } from "./MacaronTickSlider";

export function renderMacaronComponent(type: string, config: RecordAny, ctx: MacaronRenderContext): ReactNode {
  switch (type) {
    case "Column":
      return <MacaronColumn config={config} ctx={ctx} />;
    case "Row":
      return <MacaronRow config={config} ctx={ctx} />;
    case "Card":
      return <MacaronCard config={config} ctx={ctx} />;
    case "Label":
      return <MacaronLabel config={config} ctx={ctx} />;
    case "Button":
      return <MacaronButton config={config} ctx={ctx} />;
    case "Divider":
      return <MacaronDivider config={config} />;
    case "LinearProgress":
      return <MacaronLinearProgress config={config} ctx={ctx} />;
    case "Rating":
      return <MacaronRating config={config} ctx={ctx} />;
    case "TagText":
      return <MacaronTagText config={config} ctx={ctx} />;
    case "FilterTags":
      return <MacaronFilterTags config={config} ctx={ctx} />;
    case "Icon":
      return <MacaronIcon config={config} ctx={ctx} />;
    case "Image":
      return <MacaronImage config={config} ctx={ctx} />;
    case "CircularProgress":
      return <MacaronCircularProgress config={config} ctx={ctx} />;
    case "Tabs":
      return <MacaronTabs config={config} ctx={ctx} />;
    case "Carousel":
      return <MacaronCarousel config={config} ctx={ctx} />;
    case "BottomBar":
      return <MacaronBottomBar config={config} ctx={ctx} />;
    case "DateTimeInput":
      return <MacaronDateTimeInput config={config} ctx={ctx} />;
    case "DropdownSelection":
      return <MacaronDropdownSelection config={config} ctx={ctx} />;
    case "MarkdownView":
      return <MacaronMarkdownView config={config} ctx={ctx} />;
    case "Map":
      return <MacaronMap config={config} ctx={ctx} />;
    case "PasswordKeypad":
      return <MacaronPasswordKeypad config={config} ctx={ctx} />;
    case "PhotoInput":
      return <MacaronPhotoInput config={config} ctx={ctx} />;
    case "RollPicker":
      return <MacaronRollPicker config={config} ctx={ctx} />;
    case "RollPickerCard":
      return <MacaronRollPickerCard config={config} ctx={ctx} />;
    case "SelectionList":
      return <MacaronSelectionList config={config} ctx={ctx} />;
    case "SelectionGrid":
      return <MacaronSelectionGrid config={config} ctx={ctx} />;
    case "SelectionWrap":
      return <MacaronSelectionWrap config={config} ctx={ctx} />;
    case "OrderedSelectionList":
      return <MacaronOrderedSelectionList config={config} ctx={ctx} />;
    case "OrderedDisplayList":
      return <MacaronOrderedDisplayList config={config} ctx={ctx} />;
    case "ActionSelectionList":
      return <MacaronActionSelectionList config={config} ctx={ctx} />;
    case "BooleanAllOf":
      return <MacaronBooleanAllOf config={config} ctx={ctx} />;
    case "BooleanAnyOf":
      return <MacaronBooleanAnyOf config={config} ctx={ctx} />;
    case "TickSlider":
      return <MacaronTickSlider config={config} ctx={ctx} />;
    case "FullScreenModal":
      return <MacaronFullScreenModal config={config} ctx={ctx} />;
    default:
      return <MacaronStub name={type} />;
  }
}
